import React, { useEffect, useState } from "react";
import './workshopRequest.scss'
import {
    useGetGeoLocationMutation,
    useOnboardWorkshopMutation,
} from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";
import {
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    OutlinedInput
} from '@mui/material';
import { toast } from "react-toastify";
import { Loader } from "react-bootstrap-typeahead";
import './workshopRequest.scss'
import { useLocation } from "react-router-dom";
interface IPROPS {
    closeModal: any
}

const WorkshopRequestOnboard: React.FC<IPROPS> = ({ closeModal }) => {
    const [nameValue, setNameValue] = useState("");
    const [addressValue, setAddressValue] = useState("");
    const [cityValue, setCityValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [countryValue, setCountryValue] = useState("");
    const [pincodeValue, setPincodeValue] = useState("");
    const [startTimeValue, setStartTimeValue] = useState("");
    const [adminNameValue, setAdminNameValue] = useState("");
    const [adminUsernameValue, setAdminUsernameValue] = useState("");
    const [endTimeValue, setEndTimeValue] = useState("");
    const [adminEmailValue, setAdminEmailValue] = useState("");
    const [adminPhoneValue, setAdminPhoneValue] = useState("");
    const [escalationPhoneValue, setEscalationPhoneValue] = useState("");
    const [image, setImage] = useState<any>("");
    const [gstNumber, setGstNumber] = useState("");
    const [selectedHolidays, setSelectedHolidays] = useState<any>([]);


    // ErrorState
    const [nameError, setNameError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [cityError, setCityError] = useState(false);
    const [stateError, setStateError] = useState(false)
    const [countryError, setCountryError] = useState(false);
    const [pincodeError, setPincodeError] = useState(false);
    const [startTimeError, setStartTimeError] = useState(false);
    const [endTimeError, setEndError] = useState(false)
    const [adminNameError, setAdminNameError] = useState(false)
    const [adminUsernameError, setAdminUsernameError] = useState(false)
    const [adminEmaiError, setAdminEmaiError] = useState(false)
    const [adminPhoneError, setAdminPhoneError] = useState(false)
    const [escalationPhoneError, setEscalationPhoneError] = useState(false)
    const [geoLoctionLoader, setGeoLocationLoader] = useState(false)
    const [storeGeoLocationData, setStoreGeoLocationData] = useState<any>("");
    const [onBoardWorkshopLoader, setOnBoardWorkshopLoader] = useState(false)
    const [gstNumberError, setGstNumberError] = useState(false)

    const location = useLocation()


    const [onboardWorkshopTrigger, { status: onboardSTatus }] = useOnboardWorkshopMutation();
    // const { data: workshopData } = useGetOnboardWorkshopDataQuery({});
    const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();


    const holidaysList = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];

    const {
        selectedBorderColor,
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();

    // useEffect(() => {
    //     if (workshopData) {
    //         setStoreWorkshopData(workshopData?.results);
    //     }
    // }, [workshopData]);

    useEffect(() => {
        if (status === "pending") {
            setGeoLocationLoader(true)
        }
        else {
            setGeoLocationLoader(false)

        }

    }, [status])

    useEffect(() => {
        if (onboardSTatus === "pending") {
            setOnBoardWorkshopLoader(true)

        }
        else {
            setOnBoardWorkshopLoader(false)
        }

    }, [onboardSTatus])

    const imageHandler = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
        }
    };

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedHolidays(typeof value === 'string' ? value.split(',') : value);
    };


    const getLocation = async (e: any) => {
        e.preventDefault();
        const locationPayload = {
            address: addressValue,
        };
        try {


            const response = await geoLocationTrigger(locationPayload);

            setStoreGeoLocationData(response?.data);
            if (response?.data) {
                toast.success("Location fetched successfully")


            }
            else if (response?.error) {
                toast.error("unabel to find the location")


            }

        } catch (error) {

        }
    };


    const onboardWorkshophandler = async () => {

        let hasError = false;

        if (!nameValue.trim()) {
            setNameError(true);
            hasError = true;
        } else {
            setNameError(false);
        }

        //   Address

        if (!addressValue.trim()) {
            setAddressError(true);
            hasError = true;
        } else {
            setAddressError(false);
        }

        //   City

        if (!cityValue.trim()) {
            setCityError(true);
            hasError = true;
        } else {
            setCityError(false);
        }

        //   State
        if (!stateValue.trim()) {
            setStateError(true);
            hasError = true;
        } else {
            setStateError(false);
        }

        //   Country

        if (!countryValue.trim()) {
            setCountryError(true);
            hasError = true;
        } else {
            setCountryError(false);
        }

        //   setPincodeError

        if (!pincodeValue.trim()) {
            setPincodeError(true);
            hasError = true;
        } else {
            setPincodeError(false);
        }

        //   Start time 
        if (!startTimeValue.trim()) {
            setStartTimeError(true);
            hasError = true;
        } else {
            setStartTimeError(false);
        }

        //   End time
        if (!endTimeValue.trim()) {
            setEndError(true);
            hasError = true;
        } else {
            setEndError(false);
        }


        //   Admin  name


        if (!adminNameValue.trim()) {
            setAdminNameError(true);
            hasError = true;
        } else {
            setAdminNameError(false);
        }

        //  Admin usernmae

        if (!adminUsernameValue.trim()) {
            setAdminUsernameError(true);
            hasError = true;
        } else {
            setAdminUsernameError(false);
        }

        //   adminEmailValue

        if (!adminEmailValue.trim()) {
            setAdminEmaiError(true);
            hasError = true;
        } else {
            setAdminEmaiError(false);
        }

        //   adminPhoneValue

        if (!adminPhoneValue.trim()) {
            setAdminPhoneError(true);
            hasError = true;
        } else {
            setAdminPhoneError(false);
        }

        //   escalationPhoneValue

        if (!escalationPhoneValue.trim()) {
            setEscalationPhoneError(true);
            hasError = true;
        } else {
            setEscalationPhoneError(false);
        }


        if (!gstNumber.trim()) {
            setGstNumberError(true);
            hasError = true;
        } else {
            setGstNumberError(false);
        }


        //  if (!adminUsernameValue.trim()) {
        //     setAdminUsernameError(true);
        //     hasError = true;
        //   } else {
        //     setAdminUsernameError(false);
        //   }



        if (hasError) return;

        const formData = new FormData();
        formData.append("workshopName", nameValue);
        formData.append("address", addressValue);
        formData.append("city", cityValue);
        formData.append("state", stateValue);
        formData.append("country", countryValue);
        formData.append("pincode", pincodeValue);
        formData.append("startTime", startTimeValue);
        formData.append("endTime", endTimeValue);
        formData.append("latitude", Number(storeGeoLocationData?.latitude)?.toFixed(6));
        formData.append("longitude", Number(storeGeoLocationData?.longitude)?.toFixed(6));
        formData.append("workShopAdministrationName", adminNameValue);
        formData.append("workShopAdministrationUserName", adminUsernameValue);
        formData.append("workShopAdministrationEmail", adminEmailValue);
        formData.append("workShopAdministrationPhoneNumber", adminPhoneValue);
        formData.append("EscalationNumber", escalationPhoneValue);
        formData.append("holiday", selectedHolidays.join(','));
        formData.append("gstNumber", gstNumber);
        formData.append("status", "pending")
        formData.append("created_by", "Garage Admin")


        if (image) {
            formData.append("workshopImage", image);
        }

        const response = await onboardWorkshopTrigger(formData);

        try {
            if (response?.data) {
                toast.success("Request sent successfully")
                if (location.pathname !== "/join-us") {
                    closeModal()
                    
                }

                   setCityValue('')
                setAddressValue('')
                setAdminUsernameValue('')
                setAdminNameValue('')
                setAdminEmailValue('')
                setCountryValue('')
                setEndTimeValue('')
                setAdminPhoneValue('')
                setEscalationPhoneValue('')
                setGstNumber('')
                setNameValue('')
                setPincodeValue('')
                // setSelectedHolidays('')
                setStartTimeValue('')
                setStoreGeoLocationData('')
                setStateValue('')
                setImage('')


                



            }
            else if ("data" in response?.error) {
                const errorData = response.error.data as Record<string, string[]>;

                const phoneError = errorData["workShopAdministrationPhoneNumber"]?.[0];
                const escalationError = errorData["EscalationNumber"]?.[0];
                const escalationEmail = errorData["workShopAdministrationEmail"]?.[0]

                if (phoneError) {
                    toast.error(phoneError);
                }

                if (escalationError) {
                    toast.error(escalationError);
                }
                if (escalationEmail) {
                    toast.error(escalationEmail);
                }

            }

        } catch (error) {
            toast.error("An error occured while onboarding the workshop")

        }

    };

    useEffect(() => {
        if (storeGeoLocationData) {
            setAddressValue(storeGeoLocationData?.formatted_address)

        }

    }, [storeGeoLocationData])

    useEffect(() => {
        if (storeGeoLocationData?.formatted_address) {
            // Extract 6-digit PIN code
            const pinMatch = storeGeoLocationData?.formatted_address.match(/\b\d{6}\b/);
            if (pinMatch) setPincodeValue(pinMatch[0]);

            // Extract last part as Country
            const parts = storeGeoLocationData?.formatted_address.split(",");
            const country = parts[parts.length - 1]?.trim();

            // Remove 6-digit pincode from state, if present
            const stateRaw = parts[parts.length - 2]?.trim();
            const state = stateRaw?.replace(/\d{6}$/, '').trim();

            const city = parts[parts.length - 3]?.trim();
            if (city) setCityValue(city);
            if (state) setStateValue(state);
            if (country) setCountryValue(country);
        }
    }, [storeGeoLocationData?.formatted_address]);



    return (
        <div className="workshop-request-onboard-cont"
            style={{
                background: "white",
                // height: "100%",
                margin: location.pathname === "/join-us" ? "180px 30px 0px 30px" : "0"
                // boxShadow: `${selectedColor}80 0px 2px 10px 2px`,
                // borderRadius: "40px",
            }}
        >
            <div className="workshop-request-onboard-heading"
                style={{
                    borderBottom: "1px solid #bfbfbf",
                    fontSize: "20px",
                    padding: "15px 25px",
                    paddingBottom: "5px",
                    color: "#626262",
                    marginBottom: "20px",
                    paddingTop: "0px"
                }}
            >
                Onboard Workshop
            </div>
            <div className="workshop-request-onboard-sub-cont"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    height: "100%",
                    padding: "10px 20px",
                }}
            >
                <div className="workshop-request-onboard-name"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: "5px",
                    }}
                >
                    <label
                        className="required"
                        style={{
                            // fontSize: "15px",
                            color: "#626262",
                            // font: "caption",
                            padding: "0 10px",
                        }}
                    >
                        Name of the Workshop
                    </label>
                    <input
                        placeholder="Workshop Name"
                        value={nameValue}
                        required
                        onChange={(e) => {
                            const lettersOnly = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // allow only letters & spaces
                            setNameValue(lettersOnly);
                            setNameError(false);
                        }}
                        style={{
                            borderRadius: "24px",
                            padding: "10px",
                            border: nameError ? "1px solid red" : "0.5px solid #BFBFBF",
                            background: "rgb(248, 233, 227)",
                        }}
                    />
                    {nameError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Workshop name is required</span>}

                </div>
                {/* Address */}

                <div className="workshop-request-onboard-input-fields" style={{ display: "flex", gap: "10px" }}>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Address
                        </label>
                        <input
                            placeholder="Address"
                            value={addressValue}
                            onChange={(e) => {
                                setAddressValue(e.target.value)
                                setAddressError(false)

                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: addressError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {addressError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Address is required</span>}

                    </div>
                    <div style={{ paddingTop: "29px" }}>
                        <button
                            style={{
                                padding: "10px 25px",
                                borderRadius: "30px",
                                background: `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: `1px solid ${selectedBorderColor}`,
                                whiteSpace: "nowrap"
                            }}
                            type="button"
                            onClick={getLocation}
                        >
                            {geoLoctionLoader ? <Loader /> : "Get location"}
                        </button>
                    </div>
                </div>
                {/* Codes */}
                <div className="workshop-request-onboard-location"
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            City
                        </label>
                        <input
                            placeholder="City"
                            value={cityValue}
                            onChange={(e) => {
                                setCityValue(e.target.value)
                                setCityError(false)
                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: cityError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {cityError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>City is required</span>}

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            State
                        </label>
                        <input
                            placeholder="State"
                            value={stateValue}
                            onChange={(e) => {
                                setStateValue(e.target.value)
                                setStateError(false)

                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: stateError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {stateError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>State is required</span>}

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            PIN Code
                        </label>
                        <input
                            placeholder="PIN Code"
                            value={pincodeValue}
                            onChange={(e) => {
                                setPincodeValue(e.target.value)
                                setPincodeError(false)
                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: pincodeError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {pincodeError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Pin Code is required</span>}

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Country
                        </label>
                        <input
                            placeholder="Country"
                            value={countryValue}
                            onChange={(e) => {
                                setCountryValue(e.target.value)

                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", width: "100%", alignItems: "center", gap: "20px" }}>


                    <div className="gst_number" style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <label>GST Number</label>
                        <input onChange={(e) => {

                            setGstNumber(e.target.value)
                            setGstNumberError(false)
                        }
                        }
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: gstNumberError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {gstNumberError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>GST number is required</span>}


                    </div>

                    <FormControl fullWidth>
                        <label className="holiday-heading">Holidays</label>
                        {/* <InputLabel>Holidays</InputLabel> */}
                        <Select
                            multiple
                            value={selectedHolidays}
                            onChange={handleChange}
                            input={<OutlinedInput />}
                            renderValue={(selected) => selected.join(', ')}
                            style={{ height: "45px" }}
                        >
                            {holidaysList.map((day) => (
                                <MenuItem key={day} value={day}>
                                    <Checkbox checked={selectedHolidays.indexOf(day) > -1} />
                                    <ListItemText primary={day} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>


                {/* Codes End */}

                {/* WOrking hours start */}
                <div className="workshop-onboard-working-hours"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <div>
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                // padding: "0 10px",
                                fontWeight: "600",
                                fontSize: "20px"
                            }}
                        >
                            Working Hours
                        </label>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                gap: "10px",
                            }}
                        >
                            <label
                                className="required"
                                style={{
                                    // fontSize: "15px",
                                    color: "#626262",
                                    // font: "caption",
                                    padding: "0 5px",
                                }}
                            >
                                Start Time
                            </label>
                            <input
                                type="time"
                                value={startTimeValue}
                                onChange={(e) =>
                                    setStartTimeValue(e.target.value)
                                }
                                style={{
                                    borderRadius: "24px",
                                    padding: "10px",
                                    border: "0.5px solid #BFBFBF",
                                    background: "rgb(248, 233, 227)",
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                gap: "10px",
                            }}
                        >
                            <label
                                className="required"
                                style={{
                                    // fontSize: "15px",
                                    color: "#626262",
                                    // font: "caption",
                                    padding: "0 10px",
                                }}
                            >
                                End Time
                            </label>
                            <input
                                type="time"
                                value={endTimeValue}
                                onChange={(e) =>
                                    setEndTimeValue(e.target.value)
                                }
                                style={{
                                    borderRadius: "24px",
                                    padding: "10px",
                                    border: "0.5px solid #BFBFBF",
                                    background: "rgb(248, 233, 227)",
                                }}
                            />
                        </div>
                    </div>
                </div>
                {/* WOrking hrs end */}

                {/* Workshop image */}
                <div className="workshop-onboard-image"
                    style={{
                        display: "flex",
                        width: "100%",
                        gap: "20px",
                        flexDirection: "column",
                    }}
                >
                    <label
                        className="required"
                        style={{
                            // fontSize: "15px",
                            color: "#626262",
                            // font: "caption",
                            padding: "0 10px",
                        }}
                    >
                        Workshop Image
                    </label>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <div
                            style={{
                                // border: "1px solid black",
                                // borderStyle: "dotted",
                                // height: "43px",
                                width: "200px",
                            }}
                        >
                            {image && (
                                <img
                                    src={URL.createObjectURL(image)}
                                    alt="preview"
                                    width={200}
                                    height={200}
                                />
                            )}
                        </div>
                        <label
                            htmlFor="upload-logo"
                            style={{
                                padding: "8px 12px",
                                backgroundColor: "#007bff",
                                borderRadius: "5px",
                                cursor: "pointer",
                                display: "inline-block",
                                //   marginBottom: "20px",
                                border: `1px solid ${selectedBorderColor}`,
                                background: `${selectedButtonBackgoundColors}`,
                                width: "120px",
                                color: `${selectedButtonColors}`,

                            }}
                        >
                            Upload Logo
                        </label>

                        <span style={{
                            fontSize: "12px",
                            color: "#666",
                            fontFamily: "karbon-semi"
                        }}>
                            Accepted formats: JPG, PNG, WEBP
                        </span>
                    </div>

                    <input
                        type="file"
                        id="upload-logo"
                        style={{ display: "none" }}
                        onChange={imageHandler}
                        accept=".jpg,.jpeg,.png,.webp"
                    />
                    {/* <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                            setWorkshopImageFile(e.target.files[0])
                        }
                    /> */}
                    {/* <button    style={{
                        padding: "10px 25px",
                        borderRadius: "20px",
                        background: `${selectedButtonBackgoundColors}`,
                        color: `${selectedButtonColors}`,
                        border: `1px solid ${selectedBorderColor}`,
                    }}>Upload</button> */}
                </div>
                {/* Workshop image ends */}
                <div className="workshop-onboard-administration" style={{ display: "flex", gap: "20px", width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Workshop Administrator Name
                        </label>
                        <input
                            placeholder="Workshop Administration Name"
                            value={adminNameValue}
                            onChange={(e) => {
                                setAdminNameValue(e.target.value)
                                setAdminNameError(false)
                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: adminNameError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />

                        {adminNameError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Name is required</span>}



                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                // fontSize: "15px",
                                color: "#626262",
                                // font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Workshop Administrator Username
                        </label>
                        <input
                            placeholder="Workshop Administrator Username"
                            value={adminUsernameValue}
                            onChange={(e) => {

                                setAdminUsernameValue(e.target.value)
                                setAdminUsernameError(false)
                            }
                            }
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: adminUsernameError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {adminUsernameError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>User name is required</span>}
                    </div>
                </div>
                <div className="workshop-onboard-administrator-email" style={{ display: "flex", gap: "20px", width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                color: "#626262",
                                padding: "0 10px",
                            }}
                        >
                            Administrator Email
                        </label>
                        <input
                            placeholder="Administrator Email"
                            value={adminEmailValue}
                            onChange={(e) => {
                                setAdminEmailValue(e.target.value)
                                setAdminEmaiError(false)
                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: adminEmaiError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {adminEmaiError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Email is required</span>}


                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                color: "#626262",
                                padding: "0 10px",
                            }}
                        >
                            Mobile Number
                        </label>
                        <input
                            type="tel"
                            placeholder="Mobile Number"
                            value={adminPhoneValue}
                            maxLength={10}
                            pattern="[0-9]{10}"
                            onChange={(e) => {
                                // Only allow numbers, max 10 digits
                                const value = e.target.value.replace(/\D/g, "");
                                if (value.length <= 10) {
                                    setAdminPhoneValue(value);
                                    setAdminPhoneError(false);
                                }
                            }}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: adminPhoneError ? "1px solid red" : "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {adminPhoneError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Mobile number is required</span>}

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                color: "#626262",
                                padding: "0 10px",
                            }}
                        >
                            Escalation Mobile Number
                        </label>
                        <input
                            placeholder="Escalation Mobile Number"
                            value={escalationPhoneValue}
                            onChange={(e) => {
                                // Allow only digits and max 10 characters
                                const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                setEscalationPhoneValue(val);
                                setEscalationPhoneError(false);
                            }
                            }
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: escalationPhoneError ? "1px solid red" : "0.5px solid #BFBFBF",

                                background: "rgb(248, 233, 227)",
                            }}
                        />
                        {escalationPhoneError && <span style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}>Escalation number is required</span>}

                    </div>
                </div>

                {/* <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <label style={{fontSize: "15px", color: "#626262", font: "caption"}}>Service type</label>
                                       <input value={addressValue} onChange={(e) => setAddressValue(e.target.value)} style={{borderRadius: "24px", padding: "10px", border: "0.5px solid #BFBFBF"}}/>

                </div> */}

                <div className="workshop-administrator-btn"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                    }}
                >
                    <button
                        className="btn btn-secondary"
                        style={{ borderRadius: "20px" }}
                    >

                        Cancel
                    </button>
                    <button
                        style={{
                            padding: "10px 25px",
                            borderRadius: "20px",
                            background: `${selectedButtonBackgoundColors}`,
                            color: `${selectedButtonColors}`,
                            border: `1px solid ${selectedBorderColor}`,
                        }}
                        onClick={onboardWorkshophandler}
                    >
                        {onBoardWorkshopLoader ? <>Saving...<Loader /></> : "Save"}

                    </button>

                </div>
            </div>

            <div>

                <iframe
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    src={`https://www.google.com/maps?q=${storeGeoLocationData?.latitude},${storeGeoLocationData?.longitude}&z=15&output=embed`}
                />
            </div>
        </div>
    );
};

export default WorkshopRequestOnboard;
